import { render } from "./PurchasingForecast.vue?vue&type=template&id=65da55de&scoped=true"
import script from "./PurchasingForecast.vue?vue&type=script&lang=js"
export * from "./PurchasingForecast.vue?vue&type=script&lang=js"

import "./PurchasingForecast.vue?vue&type=style&index=0&id=65da55de&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65da55de"]])

export default __exports__